import { AxiosError } from 'axios';

import { store } from '@/store';

export function handleAxiosError(error: AxiosError, defaultMessage = 'Une erreur inconnue est survenue'): Promise<never> {
	let errorMessage: string;

	if (!error.response || error.response.status >= 500) {
		errorMessage = defaultMessage;
	} else {
		errorMessage = error.response.data.message || defaultMessage;
	}

	store.dispatch('notification/add', {
		type: 'error',
		message: errorMessage
	});

	return Promise.reject(error);
}
